// NATIVE REVIEW REQUIRED: Tamil names for the garment nouns retailers configure. Unknown nouns
// fall back to the English noun (a brand-new garment type is better shown in English than
// mistranslated).
const TAMIL_GARMENT_NOUNS: Record<string, string> = {
	saree: "சேலை",
	lehenga: "லெஹங்கா",
	kurta: "குர்தா",
	kurti: "குர்த்தி",
	chudidar: "சுடிதார்",
	salwar: "சல்வார்",
	"half saree": "தாவணி",
	dhoti: "வேட்டி",
	sherwani: "ஷெர்வானி",
};

export const tamilGarmentNoun = (englishNoun: string): string =>
	TAMIL_GARMENT_NOUNS[englishNoun.trim().toLowerCase()] ?? englishNoun;
